export default __webpack_public_path__ + "static/ani-kolleshi-7-jjn-j-qa-9-f-y-unsplash-eb4b7e10a588e5ebab243dc80c03a417.png";